"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentStoreWithRevokeReasons__factory = void 0;

var _ethers = require("ethers");

/* Autogenerated file. Do not edit manually. */

/* tslint:disable */

/* eslint-disable */
class DocumentStoreWithRevokeReasons__factory extends _ethers.ContractFactory {
  constructor(signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(_name, owner, overrides) {
    return super.deploy(_name, owner, overrides || {});
  }

  getDeployTransaction(_name, owner, overrides) {
    return super.getDeployTransaction(_name, owner, overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.DocumentStoreWithRevokeReasons__factory = DocumentStoreWithRevokeReasons__factory;
const _abi = [{
  inputs: [{
    internalType: "string",
    name: "_name",
    type: "string"
  }, {
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "DocumentIssued",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "DocumentRevoked",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "reason",
    type: "uint256"
  }],
  name: "DocumentRevokedWithReason",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "previousAdminRole",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "newAdminRole",
    type: "bytes32"
  }],
  name: "RoleAdminChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleRevoked",
  type: "event"
}, {
  inputs: [],
  name: "DEFAULT_ADMIN_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "ISSUER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "REVOKER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32[]",
    name: "documents",
    type: "bytes32[]"
  }],
  name: "bulkIssue",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32[]",
    name: "documents",
    type: "bytes32[]"
  }],
  name: "bulkRevoke",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32[]",
    name: "documents",
    type: "bytes32[]"
  }, {
    internalType: "uint256",
    name: "reason",
    type: "uint256"
  }],
  name: "bulkRevoke",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  name: "documentIssued",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  name: "documentRevoked",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "getIssuedBlock",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }],
  name: "getRoleAdmin",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "grantRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "hasRole",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "isIssued",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }, {
    internalType: "uint256",
    name: "blockNumber",
    type: "uint256"
  }],
  name: "isIssuedBefore",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "isRevoked",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }, {
    internalType: "uint256",
    name: "blockNumber",
    type: "uint256"
  }],
  name: "isRevokedBefore",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "issue",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "name",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "renounceRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "revoke",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }, {
    internalType: "uint256",
    name: "reason",
    type: "uint256"
  }],
  name: "revoke",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  name: "revokeReason",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "revokeRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "version",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}];
const _bytecode = "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";